import React from 'react'
import ProfileMenu from './ProfileMenu'
import LiveSearch from './LiveSearch'
import styles from './style.module.scss'

class TopBar extends React.Component {
  render() {
    return (
      <div className={styles.topbar}>
        <div className="mr-auto" />

        <div className="mr-0">
          <LiveSearch />
        </div>
        <ProfileMenu />
      </div>
    )
  }
}

export default TopBar
